import { Divider } from '@shared/components';

import { FinishTaskButton } from '../../components';
import { PageHeaderActionVariant } from '../../constants';
import {
  useQuestionCreationTaskDetails,
  useQuestionCreationTaskDetailsModal,
} from '../../providers';
import { getPageHeaderActionVariant } from '../../utils';

export default function MyTaskPageHeaderAction() {
  const { openIncompleteQuestionCreationTaskModal, openFinishTaskModal } =
    useQuestionCreationTaskDetailsModal();
  const { status, roles, task } = useQuestionCreationTaskDetails();
  const variant = getPageHeaderActionVariant(roles, status.code);

  const singleQuestionCount = task.metadata?.requirement?.questionCreationCount ?? 0;
  const requiredSingleQuestionCount = task.metadata?.requirement?.requiredQuestionCount ?? 0;
  const itemSetQuestionCount = task.metadata?.requirement.itemSetCondition?.map((itemSet) => {
    const questionCreationCount =
      task.metadata?.requirement.itemSetCreation?.filter(
        (creation) =>
          creation.size === itemSet.size && creation.questionCreationCount === itemSet.size,
      ).length ?? 0;
    return {
      size: itemSet.size,
      count: questionCreationCount,
      requiredCount: itemSet.needTotal,
    };
  });

  const isItemSetCreationComplete = itemSetQuestionCount?.every(
    (itemSet) => itemSet.count >= itemSet.requiredCount,
  );

  const handleFinishTask = () => {
    if (requiredSingleQuestionCount - singleQuestionCount > 0 || !isItemSetCreationComplete) {
      openIncompleteQuestionCreationTaskModal();
    } else {
      openFinishTaskModal();
    }
  };

  switch (variant) {
    case PageHeaderActionVariant.FINISH_TASK:
      return (
        <>
          <Divider orientation='vertical' flexItem />
          <FinishTaskButton onFinish={handleFinishTask} />
        </>
      );
    default:
      return null;
  }
}
